import { isSearchResultJiraIssue } from '@atlassian/search-client/jira';

import type { SearchResultItem } from './types.tsx';

/**
 * Extracts the Jira workItem key from an search result if the product is Jira.
 * @param result SearchResultItem
 * @returns The workItem key string if present and product is Jira, otherwise undefined.
 */
export const getJiraWorkItemKeyFromSearchResult = (
	result: SearchResultItem,
): string | undefined => {
	if (isSearchResultJiraIssue(result.data)) {
		return result.data.issue?.key;
	}
	return undefined;
};
